import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { escutarIngressos } from "../services/firebase";
import { excluirIngresso } from "../services/api";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";

const K = {
  bg:"#F0F4F8",sur:"#FFF",alt:"#E2E8F0",brd:"#CBD5E1",
  ink:"#004058",mid:"#475569",lt:"#94A3B8",
  red:"#ef5350",redBg:"#ffebee",
  grn:"#007f48",grnBg:"#e8f5e9",
  amb:"#D97706",ambBg:"#FEF3C7",
  mp:"#009EE3",
};

export default function ClientDashboard() {
  const { user, sair } = useAuth();
  const navigate = useNavigate();
  const [ingressos, setIngressos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletandoId, setDeletandoId] = useState(null);

  useEffect(() => {
    if (!user) {
      navigate("/");
      return;
    }
    const unsub = escutarIngressos(user.uid, (t) => {
      setIngressos(t);
      setLoading(false);
    });
    return unsub;
  }, [user, navigate]);

  const handleDelete = async (id) => {
    if (!window.confirm("Deseja realmente cancelar este pedido pendente?")) return;
    setDeletandoId(id);
    try {
      await excluirIngresso(id);
    } catch (e) {
      alert("Erro ao cancelar: " + e.message);
    }
    setDeletandoId(null);
  };

  const statusStyle = {
    confirmed: { label: "Confirmado", c: K.grn, bg: K.grnBg },
    pending: { label: "Aguardando Pagamento", c: K.amb, bg: K.ambBg },
    rejected: { label: "Recusado/Cancelado", c: K.red, bg: K.redBg },
  };

  const pendentes = ingressos.filter(i => i.status === "pending");
  const concluidos = ingressos.filter(i => i.status !== "pending");

  const renderTicket = (t) => {
    const st = statusStyle[t.status] || statusStyle.pending;
    return (
      <div key={t.id} style={{background:K.sur, border:`1px solid ${K.brd}`, borderRadius:12, marginBottom:20, boxShadow:"0 4px 12px rgba(0,0,0,0.03)", position:"relative", overflow:"hidden", opacity: t.status==="rejected"?0.6:1}}>
        <div style={{height:6, background: t.eventoColor || K.ink}} />
        <div style={{padding:"20px 24px"}}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16, gap:12}}>
            <div>
              <p style={{fontSize:11, color:K.lt, textTransform:"uppercase", letterSpacing:"1px", marginBottom:4}}>Ingresso {t.quantidade>1?`(${t.quantidade}x)`:""}</p>
              <h4 style={{fontFamily:"'Poppins',sans-serif", fontSize:20, color:K.ink, lineHeight:1.2}}>{t.eventoTitulo}</h4>
            </div>
            <span style={{display:"inline-flex",alignItems:"center",gap:3,background:st.bg,color:st.c,borderRadius:999,padding:"4px 12px",fontSize:12,fontWeight:600}}>{st.label}</span>
          </div>

          <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(120px, 1fr))", gap:12, marginBottom:20, paddingBottom:20, borderBottom:`1px solid ${K.alt}`}}>
            {t.eventoData && (
              <div>
                <p style={{fontSize:11, color:K.lt, textTransform:"uppercase"}}>Data e Hora</p>
                <p style={{fontSize:14, fontWeight:600, color:K.ink}}>{t.eventoData} às {t.eventoHora}</p>
              </div>
            )}
            {t.eventoLocal && (
              <div>
                <p style={{fontSize:11, color:K.lt, textTransform:"uppercase"}}>Local</p>
                <p style={{fontSize:14, fontWeight:600, color:K.ink}}>{t.eventoLocal?.split("—")[0]}</p>
              </div>
            )}
            <div>
              <p style={{fontSize:11, color:K.lt, textTransform:"uppercase"}}>Código</p>
              <p style={{fontSize:14, fontWeight:600, color:K.ink, fontFamily:"monospace"}}>{t.id}</p>
            </div>
          </div>

          {t.status === "confirmed" && (
            <div style={{textAlign:"center", padding:"10px 0"}}>
              <p style={{fontSize:12, color:K.mid, marginBottom:12}}>Apresente este QR Code na portaria</p>
              <QRCodeSVG value={t.id} size={160} fgColor={K.ink} bgColor="transparent" />
            </div>
          )}
          
          {t.status === "pending" && t.qrCodeBase64 && (
            <div style={{textAlign:"center", padding:"10px 0"}}>
              <p style={{fontSize:12, color:K.mid, marginBottom:12}}>Escaneie o QR Code abaixo no seu app de banco para pagar via PIX:</p>
              <img src={`data:image/jpeg;base64,${t.qrCodeBase64}`} alt="QR Code PIX" style={{width: 200, height: 200, borderRadius: 8}} />
              <div style={{marginTop: 10}}>
                <button onClick={() => {
                  navigator.clipboard.writeText(t.qrCode);
                  alert("Código PIX copiado!");
                }} style={{background:K.ink,color:"#fff",border:"none",padding:"10px 16px",borderRadius:8,cursor:"pointer",fontSize:13,fontWeight:600}}>
                  Copiar Código PIX
                </button>
              </div>
            </div>
          )}

          {t.status === "pending" && t.linkPagamento && !t.qrCodeBase64 && (
            <div style={{display:"flex", gap:8, marginTop:10}}>
              <button style={{flex:1, background:K.mp,color:"#fff",border:"none",padding:"12px",borderRadius:8,cursor:"pointer",fontWeight:600}} onClick={()=>window.open(t.linkPagamento,"_blank")}>Concluir Pagamento</button>
            </div>
          )}

          {t.status === "pending" && (
            <div style={{marginTop:12}}>
              <button style={{background:"transparent",color:K.red,border:`1px solid ${K.red}`,padding:"8px 16px",borderRadius:8,cursor:"pointer",fontSize:13}} disabled={deletandoId===t.id} onClick={()=>handleDelete(t.id)}>Cancelar Inscrição</button>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{fontFamily:"'Open Sans',sans-serif",background:K.bg,color:K.ink,minHeight:"100vh"}}>
      {/* Header Profissional */}
      <nav style={{background:K.sur,borderBottom:`1px solid ${K.brd}`,padding:"0 24px",height:64,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:50,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
        <div style={{display:"flex", alignItems:"center", gap: 20}}>
          <span style={{fontFamily:"'Poppins',sans-serif",fontSize:22,fontWeight:800,color:K.ink,cursor:"pointer"}} onClick={()=>navigate("/")}>Eventos<span style={{color:"#009EE3"}}>&</span><span style={{color:K.ink}}>Encontros</span></span>
          <span style={{color:K.lt}}>|</span>
          <span style={{fontWeight:600,color:K.mid}}>Painel do Participante</span>
        </div>
        <div style={{display:"flex",gap:16,alignItems:"center"}}>
          <span style={{fontSize:14,color:K.mid}}>{user?.email}</span>
          <button onClick={()=>{sair();navigate("/");}} style={{background:"transparent",border:`1px solid ${K.brd}`,color:K.mid,padding:"6px 16px",borderRadius:999,cursor:"pointer",fontWeight:600,fontSize:13}}>Sair</button>
        </div>
      </nav>

      <div style={{maxWidth:900,margin:"0 auto",padding:"40px 24px"}}>
        <h2 style={{fontFamily:"'Poppins',sans-serif",fontSize:28,color:K.ink,marginBottom:32}}>Meus Ingressos</h2>
        
        {loading ? (
          <div style={{textAlign:"center",padding:40,color:K.lt}}>Carregando...</div>
        ) : ingressos.length === 0 ? (
          <div style={{textAlign:"center",padding:60,background:K.sur,borderRadius:16,border:`1px dashed ${K.brd}`,color:K.lt}}>
            <p style={{fontSize:16,marginTop:12}}>Você ainda não tem ingressos.</p>
            <button onClick={()=>navigate("/")} style={{marginTop:16,background:K.ink,color:"#fff",border:"none",padding:"10px 20px",borderRadius:8,cursor:"pointer"}}>Explorar Eventos</button>
          </div>
        ) : (
          <div>
            {pendentes.length > 0 && (
              <div style={{marginBottom: 40}}>
                <h3 style={{fontSize:16, fontWeight:700, color:K.amb, textTransform:"uppercase", marginBottom:16}}>Pagamento Pendente</h3>
                {pendentes.map(renderTicket)}
              </div>
            )}
            
            {concluidos.length > 0 && (
              <div>
                <h3 style={{fontSize:16, fontWeight:700, color:K.ink, textTransform:"uppercase", marginBottom:16}}>Ingressos Registrados</h3>
                {concluidos.map(renderTicket)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
